import { render, staticRenderFns } from "./MoviesList.vue?vue&type=template&id=7822585c&scoped=true&"
import script from "./MoviesList.vue?vue&type=script&lang=js&"
export * from "./MoviesList.vue?vue&type=script&lang=js&"
import style0 from "./MoviesList.vue?vue&type=style&index=0&id=7822585c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822585c",
  null
  
)

export default component.exports